/* eslint-disable import/no-cycle */
import ApproveSalaryDetailTemplate from './components/ApproveDetailTemplate';

export type KTApproveParamsForm = {
  codeDetail: string;
  bankId?: OptionType,
  dateTransfer: string,
  methodTransfer?: OptionType,
  description: string;
};

const ApproveSalaryDetail: React.FC<ActiveRoles> = ({
  roleCreate, roleIndex, roleOther, roleUpdate, roleView
}) => (
  <ApproveSalaryDetailTemplate
    roleCreate={roleCreate}
    roleIndex={roleIndex}
    roleOther={roleOther}
    roleUpdate={roleUpdate}
    roleView={roleView}
  />
);

export default ApproveSalaryDetail;
